<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
        <span>{{"companies.basic_information"|translate}}</span>
      </div>
      <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <form class="display_form" [formGroup]="form">
      <div class="inline_block">
        <div class="input_field w-50">
          <label>{{"inventory.retail_pricee"|translate}}<span class="red">*</span></label>
          <input
            class="input"
            type="number"
            min="0"
            formControlName="sales_price"
            [placeholder]="'inventory.retail_pricee'|translate"
            (input)="sanitize($event)"
          />
          <span class="error_ms" *ngIf="form.get('sales_price')?.touched && form.get('sales_price')?.errors?.['required']">{{"common.required_field"|translate}}</span>
          <span class="error_ms" *ngIf="form.get('sales_price')?.touched && form.get('sales_price')?.errors?.['min']">{{"inventory.price_must_be_positive"|translate}}</span>
        </div>
        <div class="input_field w-50">
          <label>{{"inventory.product_cost_(cogs)"|translate}}</label>
          <input
            class="input"
            type="number"
            min="0"
            formControlName="cost"
            [placeholder]="'inventory.product_cost_(cogs)'|translate"
            (input)="sanitize($event)"
          />
          <span class="error_ms" *ngIf="form.get('cost')?.touched && form.get('cost')?.errors?.['min']">{{"inventory.price_must_be_positive"|translate}}</span>
        </div>
      </div>
      <div *ngFor="let currency of addedCurrencies" class="inline_block">
        <div class="field" [formGroup]="currency.controls['retail_price']">
          <label>{{ 'inventory.retail_pricee' | translate }} ({{ currency.data.name }})</label>
          <input type="number" formControlName="amount" [placeholder]="'inventory.retail_price_currency' | translate:{currency: currency.data.name}" min="0" />
          <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
        </div>

        <div class="field" [formGroup]="currency.controls['cost']">
          <label>{{ "inventory.product_cost_(cogs)" | translate }} ({{ currency.data.name }})</label>
          <input type="number" formControlName="amount" [placeholder]="'inventory.product_cost_(cogs)_currency' | translate:{currency: currency.data.name}" min="0" />
          <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
        </div>
        <button class="remove-currency" *appHasPermission="{ module: 'product', action: 'edit' }" type="button" (click)="removeCurrency(currency.data.id)">
          <img src="assets/icones/delete_btn.svg" alt="">
        </button>
      </div>
      <div class="btn_attributes">
        <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
          <span *ngIf="availableCurrencies.length > 0" class="add-currency-button" #dropdown>
            <button class="add_attr" type="button" (click)="openCurrenciesDropdown($event)">
              <img src="../../../../../assets/icones/add_icon.svg" alt="">
              <span> {{"inventory.add_other_currencies"|translate}}</span>
            </button>

            <div *ngIf="showCurrencyDropdown" class="currency-dropdown"
              [style.top.px]="currenciesDropdown.top"
              [style.left.px]="currenciesDropdown.left"
              [style.minWidth.px]="currenciesDropdown.minWidth"
            >
              <ul>
                <li *ngFor="let currency of availableCurrencies" (click)="addCurrency(currency)">
                  {{ currency.name }} ({{ currency.symbol }})
                </li>
              </ul>
            </div>
          </span>
        </ng-container>
      </div>
    </form>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="save()">
        <span> {{"common.save"|translate | uppercase}} </span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
